import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Client, ClientLite } from './client';


@JsonObject('ClientSearchResults')
export class ClientSearchResults extends SearchResults {
    @JsonProperty('results', [Client])
    results: Client[] = [];
}

@JsonObject('ClientLiteSearchResults')
export class ClientLiteSearchResults extends SearchResults {
    @JsonProperty('results', [ClientLite])
    results: ClientLite[] = [];
}
